module.exports = __webpack_public_path__ + "static/media/profile.8db2c05a.png";